{
  "alert": "Výstraha",
  "dismiss": "Odstranit"
}
